import ContentLoader from "react-native-easy-content-loader";
import { useAppTheme } from "../useAppTheme";
import { useDevice } from "../useDevice";
import Box from "./Box";

type Props = {
	numItems?: number;
};
const QuickActionChipsSkeleton = ({ numItems = 3 }: Props) => {
	const theme = useAppTheme();

	const { isMobile } = useDevice();
	return (
		<Box
			flexDirection="row"
			gap={8}
			alignItems="center"
			flex={1}
			paddingHorizontal={isMobile ? 16 : 0}
		>
			{Array.from({ length: numItems }).map((_, index) => (
				//@ts-ignore
				<ContentLoader
					// biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
					key={index}
					paragraphStyles={{
						borderRadius: theme.roundness,
					}}
					containerStyles={{
						paddingHorizontal: 0,
						width: 100,
						marginTop: -8,
					}}
					active
					title={false}
					pRows={1}
					pHeight={30}
					pWidth={100}
				/>
			))}
		</Box>
	);
};

export default QuickActionChipsSkeleton;
